<template>
  <div>
    <div class="breadlist xx">
      <bread-list :routeQuery="routeQuery"></bread-list>
    </div>
    <div class="teacher-detail">
      <div class="teacher-top fs-md d-flex">
        <div
          class="basic-img"
          style="border-radius: 50%; border: 1px solid #ededed"
        >
          <img :src="getClubImg(teamData.path)" @error="headError" />
        </div>
        <div class="basic-info weight">
          <div class="line d-flex">
            <div class="label">队伍名：</div>
            {{ teamData.sportTeamName }}
          </div>
          <div class="line d-flex">
            <div class="label">人&nbsp;&nbsp;&nbsp;数：</div>
            {{ teamData.number }}
          </div>
          <div class="line d-flex">
            <div class="label">简&nbsp;&nbsp;&nbsp;介：</div>
            {{
              teamData.sportTeamIntroduction
                ? teamData.sportTeamIntroduction
                : '暂未维护'
            }}
          </div>
        </div>
      </div>
      <div style="margin-top: 16px">
        <div class="item d-flex">
          <div class="item-logo"></div>
          <div class="item-title weight fs-lg">队伍成员</div>
        </div>
        <div class="item-content" style="margin-left: 16px">
          <div
            class="d-column"
            v-for="item in teamData.memberList"
            :key="item.sportTeamPlayerId"
            style="
              width: calc(100% - 32px);
              border: 1px solid #d1d1d1;
              border-radius: 8px;
              padding: 16px;
            "
          >
            <div class="d-flex" style="margin-bottom: 16px">
              <!-- <img
                :src="item.path"
                class="memberPhoto"
                style="border-radius: 50%; border: 1px solid #ededed"
              /> -->
              <img
                :src="getClubMenberImg(item)"
                class="memberPhoto"
                @error="headError"
                style="border-radius: 50%; border: 1px solid #ededed"
              />
              <div
                class="d-column"
                style="margin-left: 16px; width: calc(100% - 100px)"
              >
                <div style="margin-top: 8px">
                  姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{
                    item.sportTeamPlayerName
                  }}
                </div>
                <div style="margin-top: 8px">
                  主要目标：{{ item.mainTarget }}
                </div>
                <!-- <div style="margin-top: 8px">职位：{{ item.type }}</div> -->
              </div>
            </div>
            <div>个人成绩：{{ item.grade ? item.grade : '暂未维护' }}</div>
          </div>
        </div>
      </div>
      <div style="margin-top: 32px">
        <div class="item d-flex">
          <div class="item-logo"></div>
          <div class="item-title weight fs-lg" style="margin-bottom: 8px">
            赛事新闻
          </div>
        </div>
        <div class="report-list">
          <li
            class="list-each j-flex fs-sm"
            v-for="item in teamGGData"
            :key="item.id"
            @click="lookDetail(item)"
          >
            <div class="d-flex title">
              <div class="circle"></div>
              <div class="a-title overflow">{{ item.title }}</div>
            </div>
            <div class="date">
              {{ item.publishDate | formateDate }}
              {{ item.date }}
            </div>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BreadList from '../../components/BreadList/indexnew.vue'
import { formateDate } from '../../assets/js/date'
import { teamBaseInfo } from '@/api/api'
export default {
  components: {
    BreadList,
  },
  data() {
    return {
      title: '队伍详情',
      teamData: {
        name: '',
        num: '',
        path: '',
        intro: '',
        memberList: [
          {
            id: 0,
            name: '',
            type: '',
            path: '',
            intro: '',
          },
        ],
      },
      teamGGData: [
        {
          id: 0,
          title: '',
          publishDate: '',
        },
      ],
      routeQuery: '',
      currModel: '',
      id: '',
    }
  },
  created() {
    this.routeQuery = this.$route.query
    this.lookInfo()
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
  },
  computed: {
    getClubImg() {
      return function (img) {
        if (img == null || img == '') {
          return require('@/assets/img/clubdefault.png')
        } else {
          return img
        }
      }
    },
    getClubMenberImg() {
      return function (item) {
        if (item.path == null || item.path == '') {
          if (item.gender == '男') {
            return require('@/assets/img/boyphoto.svg')
          } else if (item.gender == '女') {
            return require('@/assets/img/photo.svg')
          }
          return require('@/assets/img/clubdefault.png')
        } else {
          return item.path
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/clubdefault.png')
    },
    lookInfo() {
      teamBaseInfo(this.routeQuery.id).then((res) => {
        if (res.data.statusCode == 1) {
          //   console.log('res:', res)
          this.teamData = res.data.obj
          this.teamData.memberList = res.data.obj.sportTeamPlayerResList
          this.teamGGData = res.data.obj.cmsContentGG
        }
      })
    },
    lookDetail(item) {
      //   let curr = ''
      //   if (str == 'ssxw') {
      //     curr = '赛事新闻'
      this.id = item.id
      //   }
      this.$router.push({
        path: '/article',
        query: {
          one: '运动竞训',
          two: '队伍详情',
          three: '赛事新闻',
          // path: '/clubInfo',
          path1: '/competition',
          path2: '/teamInfo',
          keepalive: 2,
          // keepchild: -1,
          articleId: this.id,
          clubtype: 'team',
          id: this.routeQuery.id,
        },
      })
      this.$store.commit('setBreadThree', this.currPrograma)
    },
  },
}
</script>
<style lang="scss" scoped>
.memberPhoto {
  width: 80px;
  height: 80px;
  //   border-radius: 4px;
}
.breadlist {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
.teacher-detail {
  width: 980px;
  padding: 24px 60px;
  margin: 0 auto;
  color: #181818;
}
.basic-img {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.basic-info {
  width: calc(100% - 160px);
  padding: 4px 24px;
  color: #2f2f2f;
  margin-top: 8px;
  .line {
    width: 100%;
    margin-bottom: 26.5px;
  }
  .label {
    width: 80px;
  }
}
.item-logo {
  width: 4px;
  height: 25px;
  background: #80bca6;
  border-radius: 3px;
}
.item-title {
  line-height: 25px;
  color: #2f2f2f;
  margin-left: 10px;
}
.item-content {
  margin-top: 20px;
  font-size: 15px;
  color: #2f2f2f;
  display: grid;
  //   grid-template-columns: 44% 44%;
  grid-template-columns: 30% 30% 30%;
  justify-items: center;
  //   grid-column-gap: 78px;
  grid-column-gap: 32px;
  grid-row-gap: 32px;
}
.polygon-one {
  //   background: #007a4d;
  //   opacity: 0.2;
  //   transform: matrix(0.98, -0.57, -0.15, 0.89, 0, 0);
  background: url('../../assets/img/Rectangle3.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 92px;
  top: -18px;
  left: -26px;
}
.polygon-two {
  background: url('../../assets/img/Rectangle1.svg') no-repeat;
  position: absolute;
  width: 108px;
  height: 120px;
  top: 600px;
  left: -170px;
}
.polygon-three {
  background: url('../../assets/img/Rectangle2.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 105px;
  top: 80px;
  left: 900px;
}
.polygon-four {
  background: url('../../assets/img/Rectangle4.svg') no-repeat;
  position: absolute;
  width: 120px;
  height: 86px;
  top: 180px;
  left: 850px;
}
.polygon-five {
  background: url('../../assets/img/Rectangle5.svg') no-repeat;
  position: absolute;
  width: 72px;
  height: 56px;
  top: 800px;
  left: 1100px;
}
.list-each {
  list-style: none;
  color: #464646;
  line-height: 36px;
  border-bottom: 1px dashed #464646;
  cursor: pointer;
  &:hover {
    color: #007a4d;
    .circle {
      background-color: #007a4d;
    }
  }
}
.report-list {
  // width: ;
  .title {
    width: calc(100% - 120px);
  }
  .date {
    width: 120px;
    text-align: right;
  }
}
</style>
